import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["map"];
  connect() {
    this.newMap();
  }
  newMap() {
    // data-json から緯度経度を取得
    this._location = Object.fromEntries(
      Object.entries(JSON.parse(this.mapTarget.dataset.json)).map(([key, value]) => [key, parseFloat(value)]),
    );
    const apiKey = document.head.querySelector("meta[name=google_api_key]").content;
    const iframe = document.createElement("iframe");
    iframe.src = this.#buildSrc(apiKey, this._location);
    iframe.loading = "lazy";
    iframe.referrerPolicy = "no-referrer-when-downgrade";
    iframe.style.border = "0";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.allowFullscreen = true;
    this.mapTarget.innerHTML = "";
    this.mapTarget.appendChild(iframe);
  }
  #buildSrc(apiKey, { lat, lng }) {
    const params = new URLSearchParams({
      key: apiKey,
      q: `${lat},${lng}`,
      zoom: 15,
    });
    return `https://www.google.com/maps/embed/v1/place?${params.toString()}`;
  }
}
